import "../pages/css/App.css";
import "../pages/css/TastingCreate.css";
import frontendLogger from "../utils/frontendLogger.js";
import useAuthUser from "../hooks/useAuthUser.js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { logout } from "../hooks/logout.js";
import { API_BASE_URL } from "../app_config.js";

function TastingCreate() {
  const { userId, loading, error } = useAuthUser();
  const [tastingMotto, setTastingMotto] = useState("");
  const [tastingDate, setTastingDate] = useState("");
  const [tastingPlace, setTastingPlace] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const handleBackToStart = () => {
    navigate("/main");
  };
  const handleSaveTasting = async (e) => {
    e.preventDefault();

    if (!userId) {
      setErrorMessage(
        "Benutzer-ID noch nicht geladen. Bitte versuchen Sie es später.",
      );
      return;
    }

    setErrorMessage("");
    setSuccessMessage("");

    const tastingData = {
      motto: tastingMotto,
      date: tastingDate,
      host_user_id: userId,
      place: tastingPlace,
    };

    frontendLogger.info("Speichere Tasting:", tastingData);

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/tastingData/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(tastingData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || "Fehler beim Speichern des Tastings",
        );
      }

      const data = await response.json();
      frontendLogger.info("Tasting gespeichert:", data);
      setSuccessMessage("Tasting erfolgreich gespeichert!");
      setTastingMotto("");
      setTastingDate("");
      setTastingPlace("");

      setTimeout(() => {
        navigate("/main");
      }, 2000);
    } catch (error) {
      frontendLogger.error("API Fehler:", error);
      setErrorMessage(error.message || "Fehler beim Speichern des Tastings");
    }
  };

  if (loading) {
    return (
      <div className="App">
        <h1 className="header">Lade...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <h1 className="header">{error}</h1>
      </div>
    );
  }

  return (
    <div className="page-layout">
      <div className="menu-container">
        <div className="title-box">
          <p>Willkommen bei DRAM</p>
        </div>
        <div className="menu-box">
          <h1>Neues Tasting anlegen</h1>
        </div>

        <nav className="nav">
          <button className="nav-button" onClick={handleBackToStart}>
            Startseite
          </button>

          <button
            className="nav-button"
            type="submit"
            form="tastingForm"
            disabled={!userId}
          >
            Tasting speichern
          </button>

          <button className="nav-button" onClick={() => logout(navigate)}>
            Abmelden
          </button>
        </nav>
        <img
          src={require("../assets/logo.png")}
          alt="Versionsinformationen anzeigen"
          className="whisky-image"
          role="button"
          tabIndex={0}
        />
      </div>

      <div className="tasting-form-group">
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <form id="tastingForm" onSubmit={handleSaveTasting}>
          <label htmlFor="tastingMotto">Tasting-Motto:</label>
          <input
            type="text"
            id="tastingMotto"
            value={tastingMotto}
            onChange={(e) => setTastingMotto(e.target.value)}
            name="tastingMotto"
            placeholder="Bitte gib ein Tasting-Motto an"
            required
          />

          <label htmlFor="tastingDate">Datum:</label>
          <input
            type="date"
            id="tastingDate"
            value={tastingDate}
            onChange={(e) => setTastingDate(e.target.value)}
            name="tastingDate"
            required
          />
          <label htmlFor="tastingPlace">Ort:</label>
          <select
            value={tastingPlace}
            onChange={(e) => setTastingPlace(e.target.value)}
          >
            <option value="">Bitte wählen</option>
            <option value="Online">Online</option>
            <option value="Vor Ort">Vor Ort</option>
          </select>
        </form>
      </div>
    </div>
  );
}

export default TastingCreate;
